// @flow
import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';

import { getPhraseBoldData, PhraseData } from '../utils/i18n';

const useStyles = makeStyles({
  bold: {
    fontWeight: 800,
  },
});

interface Props {
  className?: string;
  phraseKey: string;
}

const PhraseMarkdownText = ({ className, phraseKey }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const phrase = t(phraseKey);

  const containsBold = phrase.includes('**');
  if (containsBold) {
    return (
      <>
        {getPhraseBoldData(phrase, '**').map((phraseData: PhraseData, index: number) => (
          <span
            key={index}
            className={classnames(className, {
              [classes.bold]: phraseData.isBold,
            })}
          >
            {phraseData.text}
          </span>
        ))}
      </>
    );
  }

  return <span className={classnames(className)}>{phrase}</span>;
};

export default PhraseMarkdownText;
